<form [formGroup]="form" *ngIf="form">
    <div class="content k-d-flex k-flex-col gap-24">
        <ng-container>
            <div class="k-d-flex district-borough">
                <kendo-floatinglabel text="School Year Term"
                    class="functional-grade-level__form-label district-borough-width">
                    <kendo-dropdownlist [data]="schoolYears" size="large" rounded="large" textField="value"
                        valueField="value" formControlName="schoolYearTerm">
                    </kendo-dropdownlist>
                </kendo-floatinglabel>

                <kendo-floatinglabel text="District" class="functional-grade-level__form-label district-borough-width">
                    <kendo-multiselect [data]="referenceData?.district" size="large" rounded="large"
                        [textField]="'description'" [valueField]="'value'" formControlName="district">
                    </kendo-multiselect>
                </kendo-floatinglabel>
            </div>
            <div class="k-d-flex district-borough">
                <kendo-floatinglabel text="Borough" class="functional-grade-level__form-label district-borough-width">
                    <kendo-dropdownlist [data]="referenceData?.borough" size="large" rounded="large"
                        textField="description" valueField="description" formControlName="borough">
                    </kendo-dropdownlist>
                </kendo-floatinglabel>

            </div>
            <div class="divider"></div>

            <div>
                <div class="k-d-inline-flex k-align-items-baseline">
                    <h4 class="k-mr-2">Class / School Types</h4>
                    <button kendoButton *ngIf="currentAction !== 'select'" class="link-button" fillMode="link"
                        themeColor="base" size="medium" (click)="toggleSelectAll(true)">( select all
                        )</button>
                    <button kendoButton *ngIf="currentAction === 'select'" class="link-button" fillMode="link"
                        themeColor="base" size="large" (click)="toggleSelectAll(false)">( deselect all
                        )</button>
                </div>
                <div class="k-mt-2">
                    <div *ngFor="let item of constants.siteTypes" class="checkbox-group">
                        <div class="checkbox-item">
                            <label>
                                <input type="checkbox" kendoCheckBox [formControlName]="item.control" />
                                {{ item.text }}
                            </label>
                        </div>

                        <div class="nested-checkbox-group" *ngIf="item.items">
                            <ul class="k-radio-list" role="radiogroup" aria-labelledby="showClassesWith">
                                <li *ngFor="let subItem of item.items; let i = index" class="k-radio-item">
                                    <input type="radio" [id]="'showClassesWith' + i" kendoRadioButton
                                        name="showClassesWith" [value]="i" formControlName="showClassesWith" />
                                    <kendo-label [for]="'showClassesWith' + i" [text]="subItem.text"></kendo-label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider"></div>
            <h4 class="!k-m-0"> Recommended Programs</h4>
            <kendo-floatinglabel text="Program" class="k-w-full">
                <kendo-multiselect [data]="programList" [textField]="'description'" [valueField]="'id'"
                    formControlName="programs"></kendo-multiselect>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Ratio" class="k-w-full">
                <kendo-multiselect [data]="referenceData?.seRatio" [textField]="'description'" [valueField]="'id'"
                    formControlName="ratio"></kendo-multiselect>
            </kendo-floatinglabel>
        </ng-container>

        <div class="k-d-flex k-justify-content-between k-pt-6">
            <button kendoButton themeColor="secondary" size="large" rounded="large" fillMode="outline"
                (click)="resetFilters()">
                Reset Filters
            </button>
            <button kendoButton themeColor="primary" size="large" rounded="large" fillMode="solid"
                (click)="onShowresults()">
                Show Results
            </button>
        </div>

    </div>
</form>